<template>
  <div class="row mx-auto">
    <vue-bootstrap-typeahead
      :data="users"
      v-model="user"
      size="lg"
      :serializer="item => `${item.first_name} ${item.last_name}`"
      placeholder="Filter by User"
      inputClass="user-autocomplete"
      ref="search"
      @hit="$emit('chosen', $event)"
    />
  </div>
</template>

<script>
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

  export default {
    name: 'UserSearchFilter',
    components: {
      VueBootstrapTypeahead
    },
    props: {
      initial: {
        default: null
      }
    },
    data() {
      return {
        users: [],
        user: ''
      };
    },
    mounted() {
      setTimeout(() => {
        if (this.initial) {
          this.axios.get(`/user?user_id=${this.initial}`)
            .then(response => {
              this.$refs.search.inputValue = this.user = response.data.first_name + ' ' + response.data.last_name
            });
        }
      }, 2000);
    },
    watch: {
      user: window._.debounce(function(usr) { this.getUsers(usr) }, 500),
      initial(newVal) {
        if (newVal != null) {
          this.axios.get(`/user?user_id=${newVal}`)
            .then(response => {
              this.$refs.search.inputValue = this.user = response.data.first_name + ' ' + response.data.last_name
            });
        }
        else {
          this.$refs.search.inputValue = this.user = '';
        }
      }
    },
    methods: {
      getUsers(query) {
        if (!this.user) {
          this.$emit('chosen', { id: null});

          return;
        }

        this.axios.get(`/users?query=${query}`)
          .then(response => this.users = response.data.users);
      }
    },
  }
</script>

<style>
  .user-autocomplete, .user-autocomplete:focus {
    background: #495966;
    border-color: #495966;
    width: 100% !important;
    border-radius: 20px !important;
    height: 3vh !important;
    color: #c2c2c2 !important;
    box-shadow: none !important;
    font-size: inherit !important;
  }
</style>
